$("#work_with_us_form").submit(function(event){
    event.preventDefault();

    var terms = $('#cv_terms');
    var email = $('#cv_email');
    var name = $('#cv_name');
    var surnames = $('#cv_surnames');
    var city = $('#cv_city');
    var region = $('#cv_region');
    var interests = $('#cv_interests');
    var file = $('#uploadCV');

    /* VALIDATE TERMS */
    if(!terms.prop('checked')) {
        alert("Debes aceptar la política de privacidad.");
        return false;
    }

    /* VALIDATE REGEX EMAIL */
    var pat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(email.val().length == 0) {
        alert("Debes introducir un email.");
        return false;
    } else {
        if(!pat.test(email.val())){
            alert("Formato de email incorrecto.");
            return false;
        }
    }

    /* VALIDATE NAME LENGTH */
    if(name.val().length === 0) {
        alert("El campo Nombre no puede estar vacío.");
        return false;
    }

    /* VALIDATE SURNAMES LENGTH */
    if(surnames.val().length === 0) {
        alert("El campo Apellidos no puede estar vacío.");
        return false;
    }

    /* VALIDATE CITY LENGTH */
    if(city.val().length === 0) {
        alert("El campo Población no puede estar vacío.");
        return false;
    }

    /* VALIDATE REGION LENGTH */
    if(region.val().length === 0) {
        alert("El campo Provincia no puede estar vacío.");
        return false;
    }

    /* VALIDATE INTERESTS LENGTH */
    if(interests.val().length === 0) {
        alert("El campo Intereses no puede estar vacío.");
        return false;
    }

    /* VALIDATE FILE LENGTH */
    if(file.val().length === 0) {
        alert("Debes adjuntar tu Currículum Vitae.");
        return false;
    }
    var data = new FormData($(this)[0]);
    data.append( 'file', file[0].files[0] );

    /* POST data to the required AP */
    $.ajax({
        url: "/ticket_form/sendCV",
        type: 'POST',
        data: data,
        processData: false,
        contentType: false,
        cache: false
        }).done(function(res) {
            if (trim(res) === "true") {
                alert("Email enviado.");
                document.location.href ="/";
            } else if(trim(res) === "false") {
                alert("Error enviando email, intentalo de nuevo más tade.");
            } else {
                alert("El tipo de archivo no válido (sólo Word y PDF.) \n O el tamaño de archivo es demasiado grande (debe ser menos de 1Mb)");
            }
    });
    return false;
});